import * as React from 'react';

import { SvgButton } from '@coursera/coursera-ui';
import { SvgDownload, SvgShare } from '@coursera/coursera-ui/svg';

import { shareUtmContentParam, shareUtmMediumParam } from 'bundles/accomplishments/constants';
import getSocialCaptions from 'bundles/accomplishments/utils/getSocialCaptions';
import withSingleTracked from 'bundles/common/components/withSingleTracked';
import ShareButtonWithModal from 'bundles/sharing-common/components/modal/ShareButtonWithModal';

import _t from 'i18n!nls/accomplishments';

import 'css!./__styles__/CertificateSharing';

const SvgTrackedButton = withSingleTracked({ type: 'BUTTON' })(SvgButton);

type Props = {
  productName: string;
  partnerName: string;
  title: string;
  shareLink?: string;
  certificatePdfLink: string;
  utmContentParam?: string;
  utmProductParam?: string;
  isCertificateOwner?: boolean;
};
const CertificateSharing = ({
  productName,
  partnerName,
  certificatePdfLink,
  utmProductParam,
  shareLink,
  isCertificateOwner,
}: Props) => {
  // If not cert owner, hide sharing capabilities
  if (!isCertificateOwner) {
    return null;
  }

  return (
    <div className="rc-CertificateSharing">
      <div className="rc-CertificateSharing__box">
        <ShareButtonWithModal
          rootClassName="rc-CertificateSharing__share-button"
          shareLink={shareLink}
          utmContentParam={shareUtmContentParam}
          utmMediumParam={shareUtmMediumParam}
          utmCampaignParam="sharing_cta"
          utmProductParam={utmProductParam}
          captions={getSocialCaptions({ productName, partnerName })}
          useCustomUrl
        >
          <SvgButton type="primary" label={_t('Share Certificate')} svgElement={<SvgShare color="#fff" size={20} />} />
        </ShareButtonWithModal>
        <SvgTrackedButton
          trackingName="certificate_sharing_download_button"
          rootClassName="rc-CertificateSharing__download-button"
          label={_t('Download Certificate')}
          svgElement={<SvgDownload isThemeDark color="var(--cds-color-blue-600)" hoverColor="#fff" size={20} />}
          type="secondary"
          tag="a"
          htmlAttributes={{
            href: certificatePdfLink,
            'data-e2e': 'certificate-pdf-link',
          }}
        />
      </div>
    </div>
  );
};

export default CertificateSharing;
